/** @format */

import React from 'react';
import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom';
import { Provider } from 'mobx-react';
import App from './components/App';
import UserStore from './stores/UserStore';
import SidebarStore from './stores/SidebarStore';
import RequestsStore from './stores/RequestsStore';
import ClientsStore from './stores/ClientsStore';
import CarPartsStore from './stores/CarPartsStore';
import CarsStore from './stores/CarsStore';
import SalesStore from './stores/SalesStore';
import VisitedStore from './stores/VisitedStore';
import StatsStore from './stores/StatsStore';
import NotificationsStore from './stores/NotificationsStore';
import WarehousesStore from './stores/WarehousesStore';

Sentry.init({
  dsn: "https://83ca967fe550152f1324dc96dcbd7ebe@o4506891342774272.ingest.us.sentry.io/4510163980582912",
  sendDefaultPii: true
});

const Root = (
  <Provider
    UserStore={UserStore}
    SidebarStore={SidebarStore}
    RequestsStore={RequestsStore}
    ClientsStore={ClientsStore}
    CarPartsStore={CarPartsStore}
    CarsStore={CarsStore}
    SalesStore={SalesStore}
    VisitedStore={VisitedStore}
    NotificationsStore={NotificationsStore}
    WarehousesStore={WarehousesStore}
    StatsStore={StatsStore}
  >
    <App />
  </Provider>
);

ReactDOM.render(Root, document.getElementById('root'));
